import { Component, OnInit } from "@angular/core";
import { UserManager } from "../../Services/UserManager/user-manager";
import { ScrollService } from "../../Services/ScrollManager/scroll.service";
import {
  trigger,
  state,
  transition,
  animate,
  style,
} from "@angular/animations";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";
@Component({
  selector: "app-lessons-information",
  templateUrl: "./lessons-information.component.html",
  styleUrls: ["./lessons-information.component.css"],
  animations: [
    trigger("trigger", [
      state("void", style({ opacity: 0 })),
      state("show", style({ opacity: 1 })),
      transition("void => *", [animate("400ms ease-in-out")]),
      transition("* => void", [animate("400ms ease-in-out")]),
    ]),
  ],
})
export class LessonsInformationComponent implements OnInit {
  currentState = "void";
  config;
  constructor(
    private um: UserManager,
    private scroll: ScrollService,
    private ls: LanguageSwitchService
  ) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }

  ngOnInit() {
    this.scroll.scrollToElement("#logo");
    this.currentState = "show";
  }

  async gotoCurrentLesson() {
    let loggedIn = await this.um.isLoggedIn();
    if (loggedIn) {
      this.um.gotoLessonHeader();
    } else {
      this.um.gotoLessonHeader(1);
    }
  }
}
